import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import avatarVideoMp4 from "../../assets/avatares/santiago-fin.mp4";
import flechaAvanzar from "../../assets/right-arrow.svg";
import { modalPresentacionManuel } from "../../utils/logger";
import ScenarioBar from "../../components/ScenarioBar";
import { useVideoWithSound } from "../../hooks/useVideoWithSound";
import "../StartGame.css";
import "./Scenario5.css";

function Scenario5Fin() {
	const navigate = useNavigate();
	const location = useLocation();

	const { videoRef, canPlayWithSound } = useVideoWithSound({
		autoPlay: true,
		volume: 0.9,
	});

	const transcription = "";

	const handleContinue = () => {
		navigate(ROUTES.FINAL_SCENE);
	};

	const activeScenario = getScenarioNumByPath(location.pathname);

	return (
		<div className="start-game-page start-game-page--welcome sc5-fin-page">
			<div className="start-game-inner">
				<div className="start-game-grid">
					<div className="start-game-visual">
						<span className="start-game-badge">
							<span className="start-game-badge-dot" aria-hidden />
							Escenario 4 · Inversión
						</span>
						<div className="start-game-avatar-wrap">
							<div className="start-game-avatar-inner">
								<video
									ref={videoRef}
									autoPlay
									muted={!canPlayWithSound}
									playsInline
									preload="auto"
									aria-label="Presentación visual"
								>
									<source src={avatarVideoMp4} type="video/mp4" />
								</video>
							</div>
						</div>
					</div>

					<div className="start-game-panel">
						<h1 className="start-game-title">
							UNIDOS INVERTIMOS; JUNTOS CONQUISTAMOS…
						</h1>
						<p className="start-game-lead italic">
							Cuando unimos fuerzas, multiplicamos oportunidades.
               				Y cuando compartimos un propósito, conquistamos nuevos horizontes
						</p>
						<p className="start-game-lead">
							El crecimiento de COBEGA no se construye solo con capital.
							Se basa en:
						</p>
						<ul className="start-game-lead">
							<li>Alianzas sólidas.</li>
							<li>Compromiso.</li>
							<li>Propósitos comunes.</li>
							<li>Compartir conocimiento.</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Scenario5Fin;
